// export const ACTION_DOWNLOANDS = "ACTION_DOWNLOANDeS";
// export const ACTION_CARGUES = 'ACTION_CARGUES';
// export const ACTION_DIALOG_ACTIVE = "ACTION_DIALOG_ACTIVE";
export const ACTION_CARGUE_EXCEL = 'ACTION_CARGUE_EXCEL';